import React, { Component } from 'react';

class Sound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false
    }
    this.audio = false;
  }

  componentDidMount() {
    window.addEventListener('keydown', (e) => {
      const {trigger} = this.props;
      if(trigger === e.key) {
        this.handleClick();
      }
    }, false);
  }

  handleClick() {
    const { sound } = this.props;
    //if(!this.state.playing) {
      this.setState({ playing: true });
      this.audio = new Audio(sound);
      this.audio.onended = () => {
        this.setState({ playing: false });
      }
      this.audio.play();
    //}


  }


  render() {
    const { original, translated, sound } = this.props;
    const { playing } = this.state;

    return <div onClick={this.handleClick.bind(this)}>
      { (playing) ? translated : original }
    </div>

  }
}


export default Sound;



// WEBPACK FOOTER //
// ./src/Sound.js